<template>
  <div :class="['loadingFullPage',{'active':setOverflow}]">
    <div class="loadingFullPage__image_container">
      <div class="imagebox">
        <img :src="this.imagePath"></img>
        <div class="imagebox__text">{{imageText}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading-full-page',
  data(){
    return {
      imagePath: this.setImagePath()
    }
  },
  props: {
    imageType: { type: String, default: 'inbox' },
    active: { type: Boolean, default: false },
    imageText: { type: String, default: '' }
  },
  methods: {
    setImagePath(){
      const inboxPath = '/static/img/common/loading_animation_inbox.gif'
      const hexaPath =  '/static/img/common/loading_animation_hexagram.gif'
      let setPath = ''

      if(this.imageType == 'inbox') {
        setPath = inboxPath
      }else if (this.imageType == 'hexagram') {
        setPath =  hexaPath
      }

      return setPath
    }
  },
  computed: {
    setOverflow() {
      if(this.active) {
        document.getElementsByTagName('html')[0].style.overflow = 'hidden'
        return true
      }else {
        document.getElementsByTagName('html')[0].style.overflow = ''
        return false
      }
    }
  }
}
</script>

<style lang="scss">
.loadingFullPage {
  width: 100%;
  height: 100%;
  max-height: 100vh;
  position: fixed;
  background: white;
  overflow: hidden;
  top: 0;
  left: 0;
  z-index: 2001;
  display: none;

  &.active {
    display: block;
  }

  &__image_container {
    width: 200px;
    height: 200px;
    position: relative;
    top: calc(50% - 100px);
    left: calc(50% - 100px);

    .imagebox {
      margin: auto;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-items: center;
      place-items: center;

      &__text {
        position: absolute;
        text-align: center;
        font-size: 10px;
        bottom: 24px;
        margin: auto;
        width: 100%;
        color: #f01278;
      }
    }
  }

  img {
    display: block;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/LoadingFullPage.vue